var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicityTrim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6284,
    cy: 8.66459,
    r: 0.666667,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62811 2.49792C9.25711 2.49792 9.96166 3.02067 10.5383 4.17371C11.1 5.29708 11.4621 6.88476 11.4621 8.66492C11.4621 10.4449 11.0999 12.0318 10.5383 13.1552C9.96164 14.3084 9.25716 14.8309 8.62811 14.8309C7.99917 14.8308 7.29545 14.3081 6.71893 13.1552C6.15728 12.0318 5.79515 10.4449 5.7951 8.66492C5.7951 6.88476 6.15725 5.29708 6.71893 4.17371C7.29543 3.02096 7.99922 2.49811 8.62811 2.49792Z",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9687 5.58081C14.2832 6.12553 14.1828 6.99707 13.4725 8.07294C12.7805 9.12106 11.5866 10.2285 10.0449 11.1186C8.50337 12.0086 6.948 12.4884 5.69437 12.5637C4.40734 12.6409 3.60254 12.2921 3.28802 11.7473C2.97371 11.2025 3.0745 10.3318 3.7847 9.25602C4.47668 8.20797 5.66992 7.1009 7.21144 6.21084C8.75311 5.32077 10.3092 4.84055 11.5629 4.7653C12.8494 4.68818 13.6541 5.03626 13.9687 5.58081Z",
    stroke: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9687 11.7482C14.2832 11.2034 14.1828 10.3319 13.4725 9.25604C12.7805 8.20792 11.5866 7.10045 10.0449 6.21038C8.50337 5.3204 6.948 4.84056 5.69437 4.76532C4.40734 4.68809 3.60254 5.0369 3.28802 5.58167C2.97371 6.12644 3.0745 6.99722 3.7847 8.07296C4.47668 9.12101 5.66992 10.2281 7.21144 11.1181C8.75311 12.0082 10.3092 12.4884 11.5629 12.5637C12.8494 12.6408 13.6541 12.2927 13.9687 11.7482Z",
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicityTrim);
export default __webpack_public_path__ + "static/media/technicity-trim.d60bb4f9539c6263d1368188d9a517f6.svg";
export { ForwardRef as ReactComponent };